module.exports = __webpack_public_path__ + "img/qua.69c1c821.png";